import * as React from 'react'
import styled from 'styled-components'
import { darkSlateBlue, paleGray } from '../../../styles/settings/colors'

const Svg = styled.svg`
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  ${({ disabled }) => disabled && `pointer-events: none`};
  cursor: pointer;
  background-color: ${paleGray};
  border-radius: 50%;
  &:hover {
    background-color: ${darkSlateBlue};
    path {
      stroke: white;
    }
  }
`

function ChevronLeft(props) {
  return (
    <Svg
      width="20px"
      height="20px"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.prefix__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
          }
        </style>
      </defs>
      <title />
      <g id="prefix__chevron-left">
        <path className="prefix__cls-1" d="M11 16l9-9M20 25l-9-9" />
      </g>
    </Svg>
  )
}

export default ChevronLeft



// WEBPACK FOOTER //
// ./src/app/elements/Icons/ChevronLeft.js